module.exports = __webpack_public_path__ + "img/IO.130668f7.svg";